import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { dailyForecastState } from '@store';

import { DailyForecastData } from '../store/types';

const getFilteredData = (data?: DailyForecastData) => {
  if (!data?.daypart?.length) {
    return [];
  }
  /**
   * Check whether to display "Today" or "Tonight" data when "Today" tile is selected based on API response
   * If every element in daypart[0] is null, then assume it's past 3PM and to display "Tonight"
   */
  const isPast3PM = Object.values(data.daypart[0])
    .map(array => array[0])
    .every(element => !element);

  const { daypartName, iconCodeExtend, precipChance, snowRange, precipType, temperature } = data.daypart[0];

  return Array.from({ length: 1 }, (_, index) => {
    const modifiedIndex = isPast3PM ? index + 1 : index;

    const snowForecasted = snowRange[modifiedIndex] ? true : false;

    return {
      isPast3PM,
      snowForecasted,
      daypartName: daypartName[modifiedIndex],
      iconCodeExtend: iconCodeExtend[modifiedIndex],
      temperature: temperature[modifiedIndex],
      precipChance: precipChance[modifiedIndex],
      precipType: precipType[modifiedIndex],
      snowRange: snowRange[modifiedIndex],
    };
  });
};

export const useTodayTonightForecast = () => {
  const { data } = useRecoilValue(dailyForecastState);

  return useMemo(() => getFilteredData(data), [data]);
};
